import React from "react";
import { Sun, Moon, Gem } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

const OPTIONS = [
  { id: "light", label: "Jour", Icon: Sun },
  { id: "dark", label: "Nuit", Icon: Moon },
  { id: "gold", label: "Or", Icon: Gem },
];

export default function ThemeToggle({ variant = "icon", idPrefix = "" }) {
  const { theme, setTheme } = useTheme();
  const full = variant === "full";

  return (
    <div
      role="group"
      aria-label="Choix du thème"
      data-testid={`${idPrefix}theme-switcher`}
      className={`vp-theme-switch ${full ? "vp-theme-switch--full" : ""}`}
    >
      {OPTIONS.map(({ id, label, Icon }) => {
        const activeOpt = theme === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => setTheme(id)}
            aria-pressed={activeOpt}
            aria-label={activeOpt ? `Thème ${label} (actif)` : `Thème ${label}`}
            title={`Thème ${label}`}
            data-active={activeOpt || undefined}
            data-testid={`${idPrefix}theme-option-${id}`}
            className="vp-theme-switch__btn"
          >
            <Icon className="w-4 h-4" aria-hidden="true" />
            {full && <span className="text-xs font-medium">{label}</span>}
          </button>
        );
      })}
    </div>
  );
}
